import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import type { AxiosError } from "axios";

import { appliesQueryKeys } from "./query-keys";
import type { ApplyDetailType } from "./types";

import { instance } from "@/lib/axios/instance";

export function useApply(
  applyId: string | undefined,
): UseQueryResult<ApplyDetailType, AxiosError> {
  return useQuery({
    queryKey: appliesQueryKeys.detail(applyId!),
    queryFn: () =>
      instance
        .get<ApplyDetailType>(`/api/v2/Applies/${applyId}`)
        .then((res) => res.data),
    enabled: !!applyId,
    staleTime: 5 * 60 * 1000,
  });
}
